<template>
  <div style="width: 70%; margin: 0 auto; margin-top: 2%">
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="渠道：">
        <channel-selector
          :disabled="!isViewMode"
          placeholder="请选择"
          @change="onChannelSelectorChange"
          ref="channelSelector"
        >
        </channel-selector>
      </el-form-item>
      <el-form-item label="各语言公告：" v-if="form.channelId != ''">
        <el-collapse accordion>
          <el-collapse-item
            v-for="languageAnnouncement in form.languageAnnouncements"
            :key="languageAnnouncement.language"
          >
            <template slot="title">
              <div>
                <label style="margin-right: 10px"
                  >[{{ languageAnnouncement.language }}]</label
                >
                <div
                  v-if="languageAnnouncement.title == ''"
                  style="display: inline-block; color: red"
                >
                  （<i class="el-icon-info" style="margin-right: 5px"></i
                  >尚未为该语言创建公告）
                </div>
              </div>
            </template>
            <div style="margin-left: 20px">
              <div>
                <label style="display: block">标题：</label>
                <el-input
                  v-model="languageAnnouncement.title"
                  :readonly="isViewMode"
                  style="width: 700px"
                ></el-input>
              </div>

              <div style="margin-top: 10px">
                <label style="display: block">正文：</label>
                <el-input
                  type="textarea"
                  rows="10"
                  v-model="languageAnnouncement.content"
                  :readonly="isViewMode"
                  style="width: 700px"
                ></el-input>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-form-item>
    </el-form>
    <div v-if="form.channelId != ''">
      <div v-if="isViewMode">
        <el-button
          type="primary"
          @click="startEdit()"
          icon="el-icon-edit"
          style="margin-left: 400px"
          >编辑</el-button
        >
      </div>
      <div style="margin-left: 350px" v-else>
        <el-button @click="cancelEdit()">取消</el-button>
        <el-button type="primary" @click="save()" style="margin-left: 50px"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("../../util");

import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      isViewMode: true, // 当前是否是在阅读模式（如果不是，那就是在编辑模式）
      availableLanguages: [], // 所有的语言
      form: {
        channelId: 0,
        languageAnnouncements: [], // 各个语言的公告
      },
    };
  },

  components: {
    ChannelSelector,
  },

  async created() {
    // 查询语言集合
    await this.getLanguageList();
  },

  methods: {
    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
      return this.getAnnouncements();
    },

    /**
     * 进入编辑模式
     */
    startEdit() {
      // 切换到编辑模式
      this.isViewMode = false;
    },

    /**
     * 取消编辑
     */
    async cancelEdit() {
      // 重新拉取公告内容
      await this.getAnnouncements();

      // 切换到阅读模式
      this.isViewMode = true;
    },

    /**
     * 保存公告
     */
    async save() {
      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/updateAnnouncement`,
          {
            channelId: this.form.channelId,
            languageAnnouncements: this.form.languageAnnouncements,
          },
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      this.$message.success("保存成功");

      // 切换到阅读模式
      this.isViewMode = true;
    },

    /**
     * 查询各个语言的公告
     */
    async getAnnouncements() {
      this.form.languageAnnouncements = [];

      var resData = (
        await axios.get(
          `${util.getBackendApiBase()}/v1/admin/getAnnouncement?channelId=${this.form.channelId}`,
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        if (resData.code != 10015) {
          this.$message.error(resData.message);
          return;
        }
      }

      for (let l of this.availableLanguages) {
        let isExist = false;

        if (resData.data.languageAnnouncements) {
          for (let la of resData.data.languageAnnouncements) {
            if (la.language == l) {
              this.form.languageAnnouncements.push({
                language: la.language,
                title: la.title,
                content: la.content,
              });

              isExist = true;
            }
          }
        }

        if (!isExist) {
          this.form.languageAnnouncements.push({
            language: l,
            title: "",
            content: "",
          });
        }
      }
    },

    /**
     * 查询语言集合
     */
    async getLanguageList() {
      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/getLanguageList`,
          {},
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        if (resData.code != 10015) {
          this.$message.error(resData.message);
          return;
        }

        return;
      }

      this.availableLanguages = resData.data.languageList || [];
    },
  },
};
</script>

<style scoped>
</style>